import { render, staticRenderFns } from "./EventLocationPicker.vue?vue&type=template&id=2edcc535&scoped=true"
import script from "./EventLocationPicker.vue?vue&type=script&lang=js"
export * from "./EventLocationPicker.vue?vue&type=script&lang=js"
import style0 from "./EventLocationPicker.vue?vue&type=style&index=0&id=2edcc535&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2edcc535",
  null
  
)

export default component.exports